module.exports = "import React from 'react';\nimport { Split, SplitItem } from '@patternfly/react-core';\n\nclass SimpleSplit extends React.Component {\n  render() {\n    return (\n      <Split>\n        <SplitItem>Secondary content</SplitItem>\n        <SplitItem isMain>Primary Content</SplitItem>\n        <SplitItem>Secondary content</SplitItem>\n      </Split>\n    );\n  }\n}\n\nexport default SimpleSplit;\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/raw-loader!../react-core/src/layouts/Split/examples/SimpleSplit.js
// module id = 465
// module chunks = 114276838955818 182305654616262